const recommendationAttributes = {
    TOPICS: 'topics',
    KEYWORDS: 'keywords',
};

export default recommendationAttributes;
